export function parseErrors(error) {
  return JSON.parse(error).errors
}

export function hasExpectedError(error, field, msg) {
  return Object.keys(error).includes(field) && error[field].includes(msg)
}

export function getErrorCount(error) {
  if (error) {
    return Object.keys(error).length
  }
}



// WEBPACK FOOTER //
// ./src/utils/error.js